import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "./hooks/user/useUser";
import { Loader } from "@datagame/ui";

export const SubscriptionRoute = (): JSX.Element => {
  const { user, loading } = useUser();

  if (loading) {
    return <Loader />;
  }

  if (user?.organization.subscription?.status === "active" || user?.organization.manuallyManagedPlan === "ADMIN") {
    return <Outlet />;
  }

  return <Navigate to="/activate" />;
};
